var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item?.delayedTill)?_c('tag',{staticClass:"blue",attrs:{"dark":"","title":_vm.title,"active":""},nativeOn:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.showDialogTaskDelay(_vm.item)}}},[_vm._v(_vm._s(_vm.delayedTill)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }